import { LoadableAfterPaint } from '@confluence/loadable';

import { EllipsisPlaceholder } from '../src/EllipsisPlaceholder.tsx';

export const LivePagesEllipsisDropdownComponent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LivePagesEllipsisDropdown" */ '../src/LivePagesEllipsisDropdown.tsx'
			)
		).LivePagesEllipsisDropdownComponent,
	loading: EllipsisPlaceholder,
});
